// The Alignova brand mark (split-apex "A" over a dental arch) and the name lockup, shared by the
// login page and every shell (lab console, clinic portal, patient app). Pure SVG — no assets.
import type { CSSProperties } from 'react';

export const BRAND_BLUE = '#1668A8';
export const BRAND_AMBER = '#F5B42A';

export function AlignovaMark({ className, style }: { className?: string; style?: CSSProperties }) {
  const teeth = Array.from({ length: 9 }, (_, i) => {
    const x = 31 + i * 7.25;
    const tt = (i - 4) / 4;
    const y = 84 + tt * tt * 7;
    return <rect key={i} x={x} y={y} width={4.4} height={11} rx={2.2} fill="currentColor" />;
  });
  return (
    <svg viewBox="0 0 120 108" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M56 26 L33 72" stroke="currentColor" strokeWidth="12.5" strokeLinecap="round" />
      <path d="M64 26 L87 72" stroke="currentColor" strokeWidth="12.5" strokeLinecap="round" />
      {teeth}
    </svg>
  );
}

/** Mark + "ALIGNOVA" wordmark, with an optional small sub-label (e.g. "Provider Portal"). */
export function AlignovaLockup({
  sub,
  size = 'md',
  color = BRAND_BLUE,
  className = '',
}: {
  sub?: string;
  size?: 'sm' | 'md';
  color?: string;
  className?: string;
}) {
  const mark = size === 'sm' ? 'h-8 w-8' : 'h-10 w-10';
  const word = size === 'sm' ? 'text-base' : 'text-lg';
  return (
    <div className={`flex items-center gap-2.5 ${className}`} style={{ color }}>
      <AlignovaMark className={mark} />
      <div className="leading-tight">
        <div className={`${word} font-extrabold tracking-[0.18em]`}>ALIGNOVA</div>
        {sub && <div className="text-[11px] font-medium tracking-wide text-muted">{sub}</div>}
      </div>
    </div>
  );
}
